class PaymentTermsUpdater extends HTMLElement {
  static observedAttributes = ["variant-id"];

  constructor() {
    super();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "variant-id" && newValue) {
      const terms = this.terms;

      if (terms) {
        terms.setAttribute("variant-id", newValue);
      }
    }
  }

  get terms() {
    return this.querySelector("shopify-payment-terms");
  }
}

if (!customElements.get("payment-terms-updater")) {
  customElements.define("payment-terms-updater", PaymentTermsUpdater);
}
